import { render, staticRenderFns } from "./ModalPriceUpdate.vue?vue&type=template&id=c71e21c0&"
import script from "./ModalPriceUpdate.vue?vue&type=script&lang=js&"
export * from "./ModalPriceUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ModalPriceUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports